import * as React from 'react';
import { useSelector } from 'react-redux';
import { FolderName } from '../../components/Notification/FolderName';
import { selectSavedInFolders } from '../../selectors';
import { getTextCount } from '../../utils/folders';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FAVORITES_URL = 'https://cian.ru/favorites';
export var DescriptionContainer = function DescriptionContainer(_ref) {
  var onClickFolderName = _ref.onClickFolderName;
  var savedInFolders = useSelector(selectSavedInFolders);
  var handleClickName = function handleClickName() {
    // Проблему покрытия тут решают тайпинги и не дадут написать код так, чтобы вызвать метод без проверки
    /* istanbul ignore next */
    if (onClickFolderName) {
      // К этому моменту уже известно, что список подборок не пуст
      onClickFolderName(savedInFolders[0].id);
    }
  };
  if (savedInFolders && savedInFolders.length === 0) {
    return /*#__PURE__*/_jsx("div", {
      children: "\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u043A"
    });
  } else if (!savedInFolders) {
    return /*#__PURE__*/_jsx("div", {
      children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435"
    });
  } else {
    var spanText = savedInFolders.length > 1 ? getTextCount(savedInFolders.length) : "\xAB".concat(savedInFolders[0].name, "\xBB");
    var folderUrl = savedInFolders && savedInFolders.length === 1 ? "".concat(FAVORITES_URL, "/?folder=").concat(savedInFolders[0].id) : '';
    return /*#__PURE__*/_jsxs("div", {
      children: ["\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E \u0432", /*#__PURE__*/_jsx(FolderName, {
        folderUrl: folderUrl,
        text: spanText,
        onClick: handleClickName
      })]
    });
  }
};